module.exports = __webpack_public_path__ + "images/help/icon-twr39@2x-e6f64f0e06d357d3cd25f22bda9975d7.png";